module.exports = __webpack_public_path__ + "media/images/flags/64/Jersey-3d909a201563c7eb6abf45542a4bad79.png";